// File: frontend/src/components/songEdit/fields/ComposerFields.tsx
import React, { useState } from 'react';
import { Person } from '../types/composerTypes';
import { ComposerForm } from '../forms/ComposerForm';
import { SearchableInput } from '../composer/SearchableInput';

interface ComposerFieldsProps {
  composer: Person | null;
  lyricist: Person | null;
  onComposerChange: (person: Person | null) => void;
  onLyricistChange: (person: Person | null) => void;
}

export const ComposerFields: React.FC<ComposerFieldsProps> = ({
  composer,
  lyricist,
  onComposerChange,
  onLyricistChange,
}) => {
  // Local state for form visibility and editing
  const [showComposerForm, setShowComposerForm] = useState(false);
  const [showLyricistForm, setShowLyricistForm] = useState(false);
  const [editingComposer, setEditingComposer] = useState<Person | null>(null);
  const [editingLyricist, setEditingLyricist] = useState<Person | null>(null);

  // Form handlers
  const handleComposerFormSubmit = (person: Person) => {
    console.log('[ComposerFields] Composer form submitted:', person);
    onComposerChange(person);
    setShowComposerForm(false);
    setEditingComposer(null);
  };

  const handleLyricistFormSubmit = (person: Person) => {
    onLyricistChange(person);
    setShowLyricistForm(false);
    setEditingLyricist(null);
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <SearchableInput
          type="composer"
          value={composer}
          onSelect={onComposerChange}
          onAddNew={() => {
            setEditingComposer({ full_name: '', type: 'composer' });
            setShowComposerForm(true);
          }}
          onEdit={() => {
            setEditingComposer(composer);
            setShowComposerForm(true);
          }}
        />
        {showComposerForm && editingComposer && (
          <ComposerForm
            type="composer"
            initialPerson={editingComposer}
            onSubmit={handleComposerFormSubmit}
            onClose={() => {
              setShowComposerForm(false);
              setEditingComposer(null);
            }}
          />
        )}
      </div>
      <div className="col-md-6">
        <SearchableInput
          type="lyricist"
          value={lyricist}
          onSelect={onLyricistChange}
          onAddNew={() => {
            setEditingLyricist({ full_name: '', type: 'lyricist' });
            setShowLyricistForm(true);
          }}
          onEdit={() => {
            setEditingLyricist(lyricist);
            setShowLyricistForm(true);
          }}
        />
        {showLyricistForm && editingLyricist && (
          <ComposerForm
            type="lyricist"
            initialPerson={editingLyricist}
            onSubmit={handleLyricistFormSubmit}
            onClose={() => {
              setShowLyricistForm(false);
              setEditingLyricist(null);
            }}
          />
        )}
      </div>
    </div>
  );
};